import cn from 'clsx';
import {MouseEventHandler} from 'react';

import css from '../styles/TabUnderlineLayout.module.css';

interface TabUnderlineLayoutProps {
  text: string;
  onClick: MouseEventHandler<any> | undefined;
  isActive: boolean;
}

const TabUnderlineLayout = ({
  text,
  onClick,
  isActive,
}: TabUnderlineLayoutProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(css.tab, {
        [css.activeTab]: isActive,
      })}
    >
      <span>{text}</span>
    </div>
  );
};

export default TabUnderlineLayout;
